<template>
  <v-dialog
    v-model="isOpenModale"
    fullscreen
    transition="slide-x-transition"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card">
      <div class="d-flex bg-titre">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          Filtrer les contrats
        </div>

        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div
        v-if="!erreur.updateFiltres"
      >
        <v-row
          class="mt-6"
          no-gutters
        >
          <v-col class="px-3">
            <AgrialSelect
              v-model="categorieContratSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.categoriesContrats"
              label="Type de contrat"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="numeroContratSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.numerosContrats"
              label="Numéro de contrat"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="etatLogistiqueSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.etatsLogistiques"
              :item-text="item => libelleFormatted(item.libelle)"
              multiple
              label="Statut de livraison"
              return-object
            >
              <template v-slot:prepend-item>
                <v-list-item 
                  title="Tous"               
                  @click="onChoixTous"
                >
                  <v-list-item-action>
                    <v-icon
                      :color="colorIcon"
                    >
                      {{ iconTous }}
                    </v-icon>
                  </v-list-item-action>              
                  <v-list-item-content>
                    <v-list-item-title :class="choixTous ? 'primary--text' : ''">
                      Tous
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2" />
              </template>           
            </AgrialSelect>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="px-3">
            <AgrialSelect
              v-model="etatPaiementSelected"
              :disabled="loading.updateFiltres"
              :items="filtresValeursPossibles.etatsPaiements"
              label="État de règlement"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            class="px-2"
            cols="6"
          >
            <BaseButton
              :is-loading="loading.updateFiltres"
              libelle-btn="Annuler"
              @click="onAnnuler"
            />
          </v-col>
          <v-col
            class="px-2"
            cols="6"
          >
            <v-tooltip
              v-if="etatLogistiqueSelected.length === 0"
              bottom
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <BaseButton
                    is-disabled
                    :is-loading="loading.updateFiltres"
                    is-color-branche
                    libelle-btn="Valider"
                  />
                </div>
              </template>
              Complétez chaque filtre pour pouvoir valider
            </v-tooltip>
            <BaseButton
              v-else
              :is-loading="loading.updateFiltres"
              is-color-branche
              libelle-btn="Valider"
              @click="onValider"
            />
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

import AgrialSelect from '@/components/form/agrial-select.vue'
import {mapActions, mapGetters} from 'vuex'
import BaseButton from '@/components/common/base-button.vue'
import capitalize from '@/filters/string.filter'

export default {
  name: 'FiltreComparaisonModal',
  components: {BaseButton, AgrialSelect},
  props: {
    isOpenModalFiltres: {
      type: Boolean,
      default:false
    }
  },
  data () {
    return {
      loading: {
        updateFiltres: false,
      },
      erreur: {
        updateFiltres: false,
      },
      isOpenModale: false,
      categorieContratSelected: null,
      numeroContratSelected: null,
      etatLogistiqueSelected: [],
      etatPaiementSelected: null,
    }
  },

  computed: {
    ...mapGetters({
      filtresAdherent: 'filtresContrat/filtresAdherent',
      filtresValeursPossibles: 'filtresContrat/filtresValeursPossibles',
    }),
    choixTous () {
      return this.etatLogistiqueSelected.length === this.filtresValeursPossibles.etatsLogistiques.length
    },    
    colorIcon () {
      return this.choixTous ? 'primary' : ''
    },
    iconTous () {
      return this.choixTous ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'
    }
  },

  created () {
    this.isOpenModale = this.isOpenModalFiltres
    this.resetAllSelects()
  },

  methods: {
    ...mapActions({
      setFiltres: 'filtresContrat/setFiltres',
    }),

    updateFiltresAdherent () {
      this.loading.updateFiltres = true
      this.erreur.updateFiltres = false

      const filtresAUpdate = {
        categorieContrat: this.categorieContratSelected,
        numeroContrat: this.numeroContratSelected,
        etatLogistique: this.choixTous ? [{code: 'TOUS', libelle: 'Tous'}] : this.etatLogistiqueSelected,
        etatPaiement: this.etatPaiementSelected,
      }
      return this.setFiltres(filtresAUpdate)
        .then(() => this.resetAllSelects())
        .catch(() => this.erreur.updateFiltres = true)
        .finally(() => this.loading.updateFiltres = false)
    },

    resetAllSelects () {
      this.categorieContratSelected = this.filtresAdherent.categorieContrat
      this.numeroContratSelected = this.filtresAdherent.numeroContrat.toString()
      this.etatLogistiqueSelected = this.filtresAdherent.etatLogistique && this.filtresAdherent.etatLogistique.map(e => e.code).includes('TOUS') ? this.filtresValeursPossibles.etatsLogistiques.slice() : this.filtresAdherent.etatLogistique
      this.etatPaiementSelected = this.filtresAdherent.etatPaiement
    },

    async onValider () {
      await this.updateFiltresAdherent()
      this.$emit('update')
    },

    onAnnuler () {
      this.resetAllSelects()
      this.$emit('close')
    },

    onClose () {
      this.$emit('close')
    },

    libelleFormatted (libelle) {
      return libelle ? capitalize.capitalize(libelle) : ''
    },

    onChoixTous () {
      if(this.choixTous) {
        this.etatLogistiqueSelected = []
      } else {        
        this.etatLogistiqueSelected = this.filtresValeursPossibles.etatsLogistiques.slice()        
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>
